import { useEffect, useState } from "react";
import { useSession, ModeNote, Panel, Label } from "./usePlay";
import { DealtCard } from "./PlayingCard";
import { BetControl } from "@/components/game/BetControl";
import { fmtAZN } from "@/lib/api";
import { sfx } from "@/lib/sound";

export const VideoPokerGame = ({ mode }) => {
  const { g, busy, call, active } = useSession("/games/videopoker", () => sfx.flip());
  const [bet, setBet] = useState(1);
  const [holds, setHolds] = useState([false, false, false, false, false]);
  useEffect(() => { if (active) setHolds([false, false, false, false, false]); }, [g?.game_id, active]);
  const toggle = (i) => { if (!active || busy) return; sfx.click(); setHolds((h) => h.map((v, k) => (k === i ? !v : v))); };
  const table = g?.paytable || [];
  return (
    <div className="grid lg:grid-cols-[340px_1fr] gap-6" data-testid="videopoker-game">
      <Panel className="order-2 lg:order-1">
        <div><Label>Mərc</Label><BetControl value={bet} onChange={setBet} disabled={active || busy} testid="vp-bet" /></div>
        <ModeNote g={g} mode={mode} />
        {active ? (
          <button disabled={busy} onClick={() => call("draw", { game_id: g.game_id, holds })} className="btn-gold w-full rounded-full py-4 font-display font-bold" data-testid="vp-draw-btn">Dəyiş ({holds.filter((h) => !h).length} kart)</button>
        ) : (
          <button disabled={busy} onClick={() => call("deal", { bet, mode })} className="btn-gold w-full rounded-full py-4 font-display font-bold" data-testid="vp-deal-btn">Payla</button>
        )}
        <p className="text-xs text-zinc-500">Saxlamaq istədiyiniz kartlara toxunun, sonra "Dəyiş" basın.</p>
      </Panel>
      <div className="order-1 lg:order-2 rounded-3xl border-4 border-[#D4AF37]/60 bg-gradient-to-b from-[#0b1a4a] to-[#050b24] p-4 sm:p-6 space-y-6 shadow-[0_0_60px_rgba(212,175,55,0.15)]" data-testid="vp-machine">
        <div className="grid grid-cols-3 sm:grid-cols-3 gap-x-4 gap-y-1 text-xs sm:text-sm font-display" data-testid="vp-paytable">
          {(table.length ? table : []).map((p) => (
            <div key={p.key} className={`flex justify-between rounded px-2 py-0.5 ${g?.hand_rank === p.key ? "bg-[#FFD700] text-black" : "text-[#FFD700]"}`}><span>{p.name}</span><span>x{p.mult}</span></div>
          ))}
          {!table.length && <p className="col-span-3 text-center text-[#FFD700] font-bold text-lg">JACKS OR BETTER · ROYAL FLUSH x800</p>}
        </div>
        <div className="flex justify-center gap-2 sm:gap-3">
          {(g?.hand || [null, null, null, null, null]).map((c, i) => (
            <button key={`${g?.game_id}-${g?.status}-${i}`} onClick={() => toggle(i)} className="flex flex-col items-center gap-2" data-testid={`vp-card-${i}`}>
              <DealtCard c={c} i={i} />
              <span className={`text-[10px] sm:text-xs font-bold tracking-[0.2em] h-5 px-2 rounded ${active && holds[i] ? "bg-[#FFD700] text-black" : "text-transparent"}`}>SAXLA</span>
            </button>
          ))}
        </div>
        <p className={`text-center font-display font-black text-xl h-8 ${g && !active ? (g.win ? "text-emerald-300" : "text-red-300") : "text-white/60"}`} data-testid="vp-result">
          {g && !active ? (g.win ? `${table.find((p) => p.key === g.hand_rank)?.name} · +${fmtAZN(g.win)}` : "Qazanc yoxdur") : active && g.hand_rank ? table.find((p) => p.key === g.hand_rank)?.name : ""}
        </p>
      </div>
    </div>
  );
};
